// Trading Demo Types and Mock Data

import axios from 'axios';

export enum PositionTypeEnum {
  Long = 'long',
  Short = 'short',
}

// Real portfolio position data from API
export interface PortfolioPositionDetailType {
  current_price: string;
  entry_price: string;
  id: string;
  opened_at: string;
  position_value: string;
  quantity: string;
  symbol_id: number;
  symbol_name: string;
  symbol_currency: string;
  unrealized_pnl: string;
  unrealized_pnl_pct: string;
  position_type: PositionTypeEnum;
  position_post: {
    post_id: number;
    user_name: string;
    user_avatar: string;
    name: string;
  } | null;
}

// Real portfolio summary data from API
export interface PortfolioSummaryType {
  cash_balance: string;
  current_exposure: string;
  daily_pnl: string;
  daily_pnl_pct: string;
  // total_pnl: string;
  total_unrealized_pnl_pct: string;
  losing_trades: number;
  max_drawdown: string;
  positions_value: string;
  total_realized_pnl: string;
  total_trades: number;
  total_unrealized_pnl: string;
  total_value: string;
  win_rate: string;
  winning_trades: number;
}

// Real portfolio transaction data from API
export interface PortfolioTransactionType {
  closed_at: string;
  entry_price: string;
  exit_price: string;
  id: string;
  quantity: string;
  realized_pnl: string;
  realized_pnl_pct: string;
  holding_duration: number;
  symbol_id: number;
  symbol_name: string;
  symbol_currency: string;
  position_type: PositionTypeEnum;
  opened_at: string;
  position_post: {
    post_id: number;
    user_name: string;
    user_avatar: string;
    name: string;
  } | null;
}

export interface PortfolioInfoType {
  data: {
    summary: PortfolioSummaryType;
    positions: PortfolioPositionDetailType[];
    transactions: PortfolioTransactionType[];
  };
}

export const callOrderRequest = async ({
  positionType,
  quantity,
  symbolId,
  postId,
}: {
  positionType: PositionTypeEnum;
  quantity: number;
  symbolId: number;
  postId: number;
}) => {
  return await axios.post(`/portfolio/positions`, {
    position_type: positionType,
    quantity: quantity,
    symbol_id: symbolId,
    ...(postId && { post_id: postId }),
  });
};

export const callGetPortfolioInfoRequest = async ({
  includePositions,
  includeTransactions,
}: {
  includePositions: boolean;
  includeTransactions: boolean;
}): Promise<PortfolioInfoType> => {
  return (
    await axios.get(
      `/portfolio/?include_positions=${includePositions.toString()}&include_transactions=${includeTransactions.toString()}`,
    )
  )?.data as PortfolioInfoType;
};

export const callSettleRequest = async ({
  quantity,
  positionId,
}: {
  quantity: number;
  positionId: number;
}) => {
  return await axios.post(`/portfolio/positions/${positionId}/close`, {
    quantity: String(quantity),
  });
};

export interface PriceInfoType {
  data: {
    balance: string;
    currency: string;
    jpy_rate: string;
    price: string;
    symbol_code: string;
    symbol_id: number;
  };
}

export const callGetPriceInfoRequest = async ({
  symbolId,
}: {
  symbolId: number;
}) => {
  return (
    await axios.get(
      `/news/charts/symbols/price/${symbolId}?is_include_cash_balance=true`,
    )
  )?.data as PriceInfoType;
};
